import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { ZpDataService } from "src/app/services/zp-data.service";
import {
  UntypedFormGroup,
  FormControl,
  Validators,
  FormArray,
  AbstractControl,
  FormBuilder,
} from "@angular/forms";
import { ThemeService } from "../theme/theme-service.service";

@Component({
    selector: "app-multi-checkbox",
    templateUrl: "./multi-checkbox.component.html",
    styleUrls: ["./multi-checkbox.component.scss"],
    standalone: false
})
export class MultiCheckboxComponent implements OnInit {
  @Input() public parentForm: UntypedFormGroup;
  @Input() public fieldId: string;
  @Input() public listSource;
  @Input() public arrayOptions;
  //@Input() itemArray;
  @Input() public label;
  @Input() public view;
  @Input() public myUser;
  public lookupItems;
  public chosen;
  public myChosenIds: string[] = [];
  public lookupSectionList: {}[] = [];
  public lookupSectionOptionList: {}[] = [];
  public myChosenList = [];
  public arrayOptionsList: any;
  public removeMobilePhone: boolean;
  //@Output() public chosenIdsChange: EventEmitter<string[]> = new EventEmitter<string[]>()

  constructor(
    private zenPlanDataService: ZpDataService,
    public themeService: ThemeService
  ) { }

  async ngOnInit() {
    let kk = 0;
    this.myChosenIds = this.parentForm.value[this.fieldId];
    console.log('myUser - ', this.myUser);
    let clientId = this.myUser ? (this.myUser.sharedPlanUserId ? this.myUser.sharedPlanUserId : this.myUser.Id) : undefined;
    console.log('clientId - ', clientId);
    this.lookupSectionList =
      await this.zenPlanDataService.getSectionItemIdsNamesAndTotals(
        clientId,
        this.listSource
      );
    console.log('lookupSectionList - ', this.lookupSectionList);
    this.arrayOptionsList = this.arrayOptions;
    let chosen = false;
    //this.lookupSectionList=this.itemArray;
    if (this.lookupSectionList != null) {
      this.lookupSectionList.forEach((item) => {
        let utilityType = item["utilityType"];
        chosen = false;
        if (this.myChosenIds.includes(item["Id"])) {
          chosen = true;
          this.myChosenList.push(item["itemName"]);
        }
        // Remove Mobile Phone from utilities list in property item
        if (
          this.fieldId == "propertyUtilities" &&
          this.myChosenIds.includes(item["utilityType"])
        ) {
          chosen = true;
          this.myChosenList.push(item["utilityType"]);
          this.removeMobilePhone = true;
        }
        // Remain only Home & Content from insurances list in property item
        if (
          this.fieldId == "propertyInsurances" &&
          this.myChosenIds.includes(item["insuranceType"])
        ) {
          chosen = true;
          this.myChosenList.push(item["insuranceType"]);
          this.removeMobilePhone = true;
        }
        item["checked"] = chosen;
      });
    }
    this.lookupSectionOptionList.forEach((item) => {
      chosen = false;
      if (this.myChosenIds) {
        chosen = true;
        this.myChosenList.push(item["itemName"]);
      }
      item["checked"] = chosen;
    });
  }

  onChange(Id, event) {
    let retVal: string[] = [];
    this.lookupSectionList.forEach((item) => {
      let myRow = document.getElementsByName(item["Id"]);
      //if(myRow[]){
      if (myRow[0]["checked"]) {
        retVal.push(myRow[0]["value"]);
      }
    });
    this.myChosenIds = retVal;
    this.parentForm.controls[this.fieldId].setValue(this.myChosenIds);
  }
}
